import React from 'react'
import utils from './utils'

function getLevelLayout(width, height, settings, quantity, answer) {

    const {
        gameContainerWidth,
        gameContainerHeight,
        sideMargin,
        dotSize,
        marginBottom,
        lineWeight,
        fontSize
    } = getLayoutSettings(width, height)

    const dotsWidth = quantity * dotSize
    const dotsMargin = (gameContainerWidth - dotsWidth) / 2 + dotSize / 2
    const colour = settings.colour || 'colour'
    let dots = []
    let lineWidth = gameContainerWidth / 20
    let line = utils.getLine(0, gameContainerHeight / 2, lineWidth, 20)

    for (let i = 0; i < quantity; i++) {
        dots.push(
            utils.getBoltWithLine(dotsMargin + dotSize * i,gameContainerHeight / 2, dotSize, lineWidth, colour)
        )
    }

    return (
        <svg
            height={gameContainerHeight}
            width={gameContainerWidth}
        >
            {line.map(value => {
                return value
            })}
            {dots.map(value => {
                return value
            })}
        </svg>
    )
}

function getLayoutSettings(gameContainerWidth, gameContainerHeight) {

    /* const gameContainerMargin = gameContainerWidth * .04

    if (gameContainerWidth * 0.6 > gameContainerHeight) {
        gameContainerWidth = gameContainerHeight / 0.6 - gameContainerMargin
        gameContainerHeight = gameContainerHeight - gameContainerMargin
    } else {
        gameContainerWidth = gameContainerWidth - gameContainerMargin
        gameContainerHeight = gameContainerWidth * 0.6 - gameContainerMargin
    } */

    const sideMargin = gameContainerWidth * .2

    const dotSize = gameContainerWidth / 10
    const marginBottom = gameContainerWidth * .1
    const lineWeight = gameContainerWidth / 150
    const fontSize = gameContainerWidth / 15

    return {
        gameContainerWidth,
        gameContainerHeight,
        sideMargin,
        dotSize,
        marginBottom,
        lineWeight,
        fontSize
    }
}

export default {
    getLevelLayout,
}


// WEBPACK FOOTER //
// ./src/components/game/levels/utils/beadStringSingle.utils.js